const MAINTENANCE_MODE =
  (process.env.REACT_APP_MAINTENANCE_MODE || 'true').toLowerCase() === 'true'

const ALLOWED_MAINTENANCE_EMAILS = (
  process.env.REACT_APP_MAINTENANCE_ALLOWED_EMAILS || 'itmanager@sfre.it'
)
  .split(',')
  .map(email => email.trim().toLowerCase())
  .filter(Boolean)

const normalizeEmail = email => (email || '').toString().trim().toLowerCase()

const isMaintenanceAllowed = user => {
  const email = normalizeEmail(user?.sfre_email || user?.email)
  return Boolean(email) && ALLOWED_MAINTENANCE_EMAILS.includes(email)
}

export {
  MAINTENANCE_MODE,
  ALLOWED_MAINTENANCE_EMAILS,
  isMaintenanceAllowed,
  normalizeEmail,
}
